<template>
    <display-field
        :field="field"
        :label-class="labelClass"
    >
        <span :class="valueClass">
            {{ value | choice(field) | capitalize | valueOrEmpty }}
        </span>
    </display-field>
</template>

<script>
    import DisplayField from "@/components/DisplayField";
    export default {
        name: "DisplayChoiceField",
        components: {DisplayField},
        props: {
            field: {
                type: Object,
                required: true,
            },
            value: {
                type: null,
                required: true,
            },
            labelClass: {
                type: String,
                default: '',
            },
            valueClass: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style scoped>

</style>